import { render, staticRenderFns } from "./Buchung.vue?vue&type=template&id=ece3b76a"
import script from "./Buchung.vue?vue&type=script&lang=js"
export * from "./Buchung.vue?vue&type=script&lang=js"
import style0 from "./Buchung.vue?vue&type=style&index=0&id=ece3b76a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports